import { Sine, TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffectKeys";
import * as Topics from "../Data/Topics";

export class LiftButton extends PIXI.Container {
    private static readonly STEAM_ANIM_KEY: string = "AnimKey";

    private _image: PIXI.Sprite;
    private _steam: HLF.AnimatedSprite;

    private _steamFadeAnim: TimelineLite | undefined;
    private _scaleTween: TweenLite | undefined;
    private _subscriptions: any[];

    constructor() {
        super();

        this._image = HLF.PixiUtils.makeSprite("button-up", Constants.SPRITESHEET_UI);
        this.addChild(this._image);

        this._steam = new HLF.AnimatedSprite();
        this._steam.addAnimation(LiftButton.STEAM_ANIM_KEY, new HLF.SpriteAnimation(
            "steam-", Constants.SPRITESHEET_UI, 11, 2,
            12, true,
        ));
        this._steam.position.set(0, 25);
        this._steam.anchor.set(0.5, 1);
        this._steam.scale.set(1.5);
        this._steam.visible = false;
        this.addChild(this._steam);

        this.interactive = true;
        this.buttonMode = true;
        this.on(HLF.Input.Events.POINTER_OVER, this.onPointerOver);
        this.on(HLF.Input.Events.POINTER_OUT, this.onPointerOut);

        this._subscriptions = new Array<any>();
        this._subscriptions.push(PubSub.subscribe(
            Topics.BALLOON_LIFT_START,
            this.onLiftStart.bind(this),
        ));
        this._subscriptions.push(PubSub.subscribe(
            Topics.BALLOON_LIFT_END,
            this.onLiftEnd.bind(this),
        ));
    }

    public update(pDeltaTime: number): void {
        this._steam.update(pDeltaTime);
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._steamFadeAnim !== undefined) { this._steamFadeAnim.kill(); }
        if (this._scaleTween !== undefined) { this._scaleTween.kill(); }
        for (let i = 0; i < this._subscriptions.length; ++i) {
            PubSub.unsubscribe(this._subscriptions[i]);
        }
        super.destroy(pOptions);
    }

    private onPointerOver(pEvent: PIXI.interaction.InteractionEvent): void {
        this.animateScale(1.025);
    }

    private onPointerOut(pEvent: PIXI.interaction.InteractionEvent): void {
        if (this._image.scale.x > 1) {
            this.animateScale(1.0);
        }
    }

    private onLiftStart(): void {
        this.showSteam();
        this.animateScale(0.95);
        Application.instance.audio.play(SFX.STEAM, 0.3, false, HLF.AudioCategory.SFX);
    }

    private onLiftEnd(): void {
        this.hideSteam();
        this.animateScale(1.0);
    }

    private showSteam(): void {
        if (this._steamFadeAnim !== undefined) { this._steamFadeAnim.kill(); }
        this._steam.play(LiftButton.STEAM_ANIM_KEY);
        this._steam.alpha = 1;
        this._steam.visible = true;
    }

    private hideSteam(): void {
        if (this._steamFadeAnim !== undefined) { this._steamFadeAnim.kill(); }
        this._steamFadeAnim = new TimelineLite();
        this._steamFadeAnim.to(this._steam, 0.3, {
            alpha: 0,
            ease: Sine.easeInOut,
        }, 0);
        this._steamFadeAnim.call(() => {
            this._steam.holdFrame(LiftButton.STEAM_ANIM_KEY, 0);
            this._steam.visible = false;
        }, undefined, this);
    }

    private animateScale(pScale: number): void {
        if (this._scaleTween !== undefined) { this._scaleTween.kill(); }

        this._scaleTween = TweenLite.to(this._image.scale, 0.15, {
            x: pScale,
            y: pScale,
            ease: Sine.easeInOut,
        });
    }
}
